export default (() => {

    // Breakpoints are also stored in styles/01-settings/-config.scss
    // Both copies should be updated in line
    const breakpoints = {
        mobile: '1rem',
        tablet: '46rem',
        tabletwide: '61rem',
        desktop: '64rem',
        wide: '81rem',
    };

    class MatchMediaList {
        constructor () {
            this.#initiateList();
        }
    
        #initiateList () {
            Object.keys(breakpoints).forEach((breakpoint) => {
                this[breakpoint] = this.#getQuery(breakpoint);
            });
        }

        #getQuery (breakpoint) {
            const currentBreakpointIndex = Object.keys(breakpoints).indexOf(breakpoint);
            const nextBreakpointKey = Object.keys(breakpoints)[currentBreakpointIndex + 1] ?? null;
    
            const currentBreakpointQuery = `(min-width: ${breakpoints[breakpoint]})`;
            const nextBreakpointQuery = nextBreakpointKey !== null
                ? `and (max-width: ${breakpoints[nextBreakpointKey]})`
                : '';
            
            const matchMedia = window.matchMedia(`${currentBreakpointQuery} ${nextBreakpointQuery}`);

            matchMedia.minWidth = breakpoints[breakpoint];
            
            return matchMedia;
        
        }
    }

    return new MatchMediaList();

})();